<template>
    <div
        class="ah-service-fee-statement-audit-progress"
        :class="[
            type,
            {
                reject: statusCode === 7,
                done: statusCode === finalStatus,
                large: size == 'large',
            },
        ]"
    >
        <div class="wrapper">
            <div class="bar"></div>
            <div class="span-bar" :style="{ width: spanBarWidth }"></div>
            <div class="curr-bar" v-if="data != null" :style="{ width: currBarWidth, left: currBarLeft }"></div>
            <div class="steps" v-if="data != null">
                <div
                    v-for="(item, index) in data"
                    :key="index"
                    class="step"
                    :class="{ passed: item.processStatus === 1 }"
                    :style="{
                        left: (index / (data.length - 1)) * 100 + '%',
                    }"
                >
                    <div class="step-name">
                        <span>{{ getStepNam(item.process) }}</span>
                    </div>
                    <span class="dot"></span>
                    <span class="content" v-if="item.processStatus">
                        <div class="title">{{ getStepNam(item.process) }}</div>
                        <div class="sub-title" v-if="item.auditorName">
                            {{ item.auditorName }}
                        </div>
                        <div class="date" v-if="item.dat">
                            {{ item.dat | dateFormater("YYYY-MM-dd") }}
                            <span v-if="item.attached">（補送）</span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';

export default {
    name: 'ah-service-fee-statement-audit-progress',
    props: {
        type: {
            type: String,
            default: 'payment',
        },
        data: {
            type: Array,
            default: () => [],
        },
        statusCode: {
            type: Number,
            default: 0,
        },
        size: {
            type: String,
            default: 'mini',
        },
        sortFlow: Boolean,
    },
    computed: {
        finalStatus() {
            return this.sortFlow ? 5 : 6;
        },
        currBarWidth() {
            if (this.data) return this.currentStepIndex === this.finalStatus ? '100%' : `${((this.currentStepIndex + 1) / this.data.length) * 100}%`;
            return 0;
        },
        currBarLeft() {
            if (this.data) return this.statusCode === 4 ? 0 : `${(this.currentStepIndex / this.data.length) * 100}%`;
            return 0;
        },
        spanBarWidth() {
            if (this.data) return `${(this.currentStepIndex / (this.data.length - 1)) * 100}%`;
            return 0;
        },
        currentStepIndex() {
            if (this.data) {
                if (this.statusCode === 7) return 0;
                for (let i = 0; i < this.data.length; i += 1) {
                    if (this.data[i].processStatus !== 1) {
                        return i;
                    }
                }
            }
            return this.data.length - 1;
        },
    },
    methods: {
        getPassed(index) {
            return this.currentStepIndex > index;
        },
        getAuditorsNameList(auditors) {
            return _.chain(auditors).map('nam').join(',').value();
        },
        getStepNam(process) {
            switch (process) {
            case 1:
                return '申請';
            case 2:
                return '領款人填寫';
            case 3:
                return '確認';
            case 4:
                return '請款';
            case 5:
                return '付款';
            case 6:
                return '領款人簽收';
            default:
                return '--';
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-service-fee-statement-audit-progress {
    height: 30px;
    width: 80%;

    &.large {
        position: relative;
        top: 22px;
        height: 85px;
        margin: 0 auto 0 auto;
        max-width: 580px;
    }

    .wrapper {
        position: relative;
        top: 10px;
        width: 100%;

        .bar {
            position: relative;
            width: 100%;
            top: 0px;
            height: 5px;
            background-color: #e4e4e4;
            border-radius: 5px;
        }

        .span-bar {
            position: absolute;
            top: -0px;
            left: 0px;
            height: 5px;
            border-radius: 10px;
            background-color: $main-color;
        }

        .steps {
            position: absolute;
            top: -2px;
            left: 0px;
            width: calc(100%);
            height: 5px;

            .step {
                position: absolute;

                .dot {
                    display: block;
                    position: relative;
                    width: 9px;
                    height: 9px;
                    border-radius: 5px;
                    background-color: #fff;
                    border: 2px solid #ccc;
                }

                .step-name {
                    position: absolute;
                    top: -33px;
                    left: -60px;
                    width: 120px;
                    text-align: center;
                    z-index: 1;
                    font-size: 10.5pt;
                    font-weight: bold;
                    color: #222;
                }

                .content {
                    display: none;
                    position: absolute;
                    top: 18px;
                    left: -60px;
                    width: 120px;
                    text-align: center;
                    z-index: 1;

                    .title {
                        display: none;
                        font-size: 10.5pt;
                        font-weight: bold;
                        color: #222;
                    }

                    .sub-title {
                        font-size: 9pt;
                        color: #666;
                    }

                    .date {
                        font-size: 9pt;
                        margin-top: -5px;
                        color: #666;
                    }
                }

                &.passed {
                    .dot {
                        border: 2px solid $main-color;
                    }
                }
            }
        }
    }

    &.reject {
        .span-bar {
            background-color: #f95d5d;
        }

        .steps {
            .step.passed {
                .dot {
                    border: 2px solid #f95d5d !important;
                }
            }
        }
    }

    &.done {
        .span-bar {
            background-color: #c6ecc2;
        }

        .steps {
            .step {
                .dot {
                    border: 2px solid #c6ecc2 !important;
                }
            }
        }
    }

    &.large {
        .wrapper > .steps > .step > .dot {
            top: -3px;
            left: -6px;
            width: 15px;
            height: 15px;
            border-radius: 15px;
            border-width: 3px;
        }

        .step-name {
            display: block;
        }

        .wrapper .steps .step .content {
            display: block;
        }
    }
}
</style>
